import type { Messages } from "@lingui/core";

import type { Locale } from "./locales";

// Каталоги лежат по частям приложения (src/<часть>/locales/<язык>.po, см. lingui.config.ts).
// Vite-плагин Lingui компилирует .po при импорте. Загружаются каталоги только нужного языка,
// и они собираются в один словарь.
const modules = import.meta.glob<{ messages: Messages }>("/src/**/locales/*.po");

export const loadCatalog = async (locale: Locale): Promise<Messages> => {
  const suffix = `/locales/${locale}.po`;
  const loaders = Object.entries(modules)
    .filter(([path]) => path.endsWith(suffix))
    .map(([, load]) => load());
  const loaded = await Promise.all(loaders);
  return loaded.reduce<Messages>((all, module) => ({ ...all, ...module.messages }), {});
};
